export const CLOUD_SETTING_BASE_URL = '/ows/beta/OutlookCloudSettings/settings/account';
export const SIGNATURE_LIST_SETTING_NAME = 'roaming_signature_list';
export const DEFAULT_SIGNATURE_SETTING_NAME = 'roaming_new_signature';
export const DEFAULT_SIGNATURE_REPLY_SETTING_NAME = 'roaming_reply_signature';
export const HTML_SIGNATURE_SETTING_NAME = 'signaturehtml';
export const TXT_SIGNATURE_SETTING_NAME = 'signaturetxt';
